import { InjectionToken } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MenuItemGroup, MenuServiceInterface } from '@app/interfaces';
import { CompanyDocument } from '@app/models/documents/company-document.model';
import { OnboardingStatusService } from '@app/modules/self-serve/services/onboarding-status.service';
import { HireEmployee } from '@app/modules/settings/meta/module-feature-permissions.meta';
import { AbilityService, AuthService } from '@app/services';
import { FeatureService } from '@app/services/feature.service';
import { MenuService } from '@app/services/menu/menu.service';
import { TranslateService } from '@ngx-translate/core';

const CompanyDocumentShowMenu: MenuItemGroup = [
    {
        key: 'document.menu.docPreview',
        link: ['/documents-v2', 'center', ':companyDocument'],
        routerLinkExact: 'ignore-query-params',
    },
    {
        key: 'document.menu.employeesAssigned',
        link: ['/documents-v2', 'center', ':companyDocument', 'assigned'],
        can: CompanyDocument.permission.view,
    },
];

const OfferLetterTemplateShowMenu: MenuItemGroup = [
    {
        key: 'document.menu.docPreview',
        link: ['/documents-v2', 'center', ':companyDocument'],
        routerLinkExact: 'ignore-query-params',
    },
    {
        key: 'document.menu.candidatesAssigned',
        link: ['/documents-v2', 'center', ':companyDocument', 'assigned'],
        can: HireEmployee.permissions,
        checkAllPermissions: true,
        routerLinkExact: true,
    },
];

/**
 * To display the correct menu, we must first determine the type of company document.
 */
export const companyDocumentsMenuServiceFactory = (
    auth: AuthService,
    abilities: AbilityService,
    feature: FeatureService,
    route: ActivatedRoute,
    onboardingStatusService: OnboardingStatusService,
    translateService: TranslateService
): MenuService => {
    const companyDocument = <CompanyDocument>route.snapshot.data.models.get('companyDocument');
    if (companyDocument.isViewOnly()) {
        // View Only Document
        return new ViewOnlyDocumentsShowMenuService(
            auth,
            abilities,
            feature,
            route,
            onboardingStatusService,
            translateService
        );
    } else if (companyDocument.isOfferLetter()) {
        // Offer letter
        return new OfferLetterTemplateShowMenuService(
            auth,
            abilities,
            feature,
            route,
            onboardingStatusService,
            translateService
        );
    } else {
        // Everything else (acknowledgement, standard_signing_document)
        return new CompanyDocumentsShowMenuService(
            auth,
            abilities,
            feature,
            route,
            onboardingStatusService,
            translateService
        );
    }
};

export const COMPANY_DOCUMENTS_TAB_MENU = new InjectionToken<MenuServiceInterface>('companyDocumentsTabMenu');

class ViewOnlyDocumentsShowMenuService extends MenuService {
    setBaseMenu(): void {
        this.baseMenu = [];
    }
}

class OfferLetterTemplateShowMenuService extends MenuService {
    setBaseMenu(): void {
        this.baseMenu = OfferLetterTemplateShowMenu;
    }
}

class CompanyDocumentsShowMenuService extends MenuService {
    setBaseMenu(): void {
        this.baseMenu = CompanyDocumentShowMenu;
    }
}
